import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { EmployeeBooking } from './employee-booking'
import { employeeBookingActions } from './employee-booking.actions'
import * as fromEmployee from './employee-booking.reducer'
import { EmployeeBookingService } from './employee-booking.service'
import { concatMap, map, tap } from 'rxjs/operators'
import { NotificationService } from 'src/app/core/notification.service'

@Injectable()
export class EmployeeBookingEffects extends ResourceEffects<EmployeeBooking> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    private employeeBookingService: EmployeeBookingService,
    private notificationService: NotificationService
  ) {
    super(
      fromEmployee.FEATURE_NAME,
      employeeBookingService,
      employeeBookingActions,
      actions$
    )
  }

  runAction = createEffect(() =>
    this.actions$.pipe(
      ofType(employeeBookingActions.runAction),
      concatMap((action) =>
        this.employeeBookingService
          .runOneAction(
            action.actionType,
            action.personId,
            action.contractId,
            action.params,
            action.invoiceText
          )
          .pipe(
            map((result: any) => {
              this.store.dispatch(
                employeeBookingActions.setLoading({ isLoading: false })
              )

              if (result?.url) {
                window.open(result.url, '__blank')
              }

              return employeeBookingActions.actionFinished({
                actionFinished: {
                  action: employeeBookingActions.runAction.type,
                  data: result?.data ?? []
                }
              })
            })
          )
      )
    )
  )
}
